import { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import { useDataSourcesApi } from "../../../hooks/useDataSource";
import { CONNECTORS } from "./_Connectors";
import * as globals from "../../../globals";
import axios from "axios";
import { getAuthHeaders } from "../../../api/restMethods";
import { ModalFrame } from "../../modal-dialog/ModalFrame";
import { NewDataSourceContext } from "../NewDataSource";
import { format } from "d3-format";
import { fileSizeFormat } from "../../../utils/FileSizeFormat";

const fmt1 = format(",.0f");


export const BlankConnector = (props) => {

    const connector_id = props.connector_id;

    const routerParams = useParams();
    const subscription_id = routerParams.subscription_id;
    const project_id = routerParams.project_id;

    const ndsContext = useContext(NewDataSourceContext);
    const { working, setWorking } = ndsContext;
    const { workStatusMessage, setWorkStatusMessage } = ndsContext;
    const { setButtonText } = ndsContext;

    // TODO:
    const fileType = connector_id; // props.fileType;
    const structured = false; // props.structured;

    const [newName, setNewName] = useState("");
    const [error, setError] = useState(null);
    const [pasting, setPasting] = useState(false);
    const [pastedData, setPastedData] = useState(null);
    const [parseInfo, setParseInfo] = useState(null);
    const auth = useAuth();
    const api = useDataSourcesApi();

    
    setButtonText("Upload");
    ndsContext.hackHandler.buttonClicked = async () => {
        let id = props.id;
        if (!props.alreadyExists) {
            id = await createDataSource();
        }
        const success = await uploadRevision(id); // returns true if success
        return success ? id : null;
    }

    const createDataSource = async () => {

        let newId = null;

        setWorkStatusMessage("Creating data source...");
        setWorking(true);
        
        try {

            // create data source
            let item = {
                type: "file",
                fileType,
                structured,
                connector: connector_id,
                label: parseInfo?.name || "Data source"
            }
            const itemInfo = await api.newItem(item);
            newId = itemInfo.newId;

        }
        catch (err) {
            setError(err.message);
        }
        setWorking(false);

        return newId;
        
    }

    const uploadRevision = async (ds_id) => {

        try {

            setWorkStatusMessage(`Uploading data [${parseInfo.name}]...`);
            setWorking(true);

            const url = `${globals.apiRoot}/subscription/${subscription_id}/project/${project_id}/data-source/${ds_id}/file`;

            let formData = {
                pastedData
            }
            if (ndsContext.notes) {
                formData.notes = ndsContext.notes;
            }

            await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    ...getAuthHeaders(auth)
                },
                onUploadProgress: (ev) => {
                    console.log("onUploadProgress", ev);
                }
            });

            setWorking(false);
            return true;
            
        }
        catch (error) {
            setError(error.message);
            setWorking(false);
            return false;
        }
    }

    

    

    return <div className='form1 new-data-source' style={{ maxWidth: 500 }}>

        <div className="upload-data-file">

            <div className="icon" style={{ fontSize: 50, float: "right", marginRight: 10 }}>
                <i className="fal fa-paste" />
            </div>

            <div className="instructions" style={{ maxWidth: 400, marginBottom: 20 }}>
                <p>
                    Blank content.
                </p>
            </div>

            <div className="input-section">
                {working ?
                    <div style={{ fontSize: "10pt", marginBottom: 5 }}>
                        Please wait. Creating data source...
                    </div>
                    : null
                }
                {(working || workStatusMessage) ?
                    <div style={{ fontSize: "10pt", marginBottom: 5 }}>
                        {workStatusMessage}
                    </div>
                    : null
                }
                
            </div>
            
        </div>

        <div className="label-line">
        </div>

        {error && !working ?
            <div>
                <p style={{ color: "red" }}>
                    <i className="fas fa-warning" />
                    &nbsp;
                    {error}
                </p>
            </div>
            : null
        }
        
    </div>


}



